module.exports = __webpack_public_path__ + "static/Sonyax47-db10b06e6b72ea895bb0b22a2341cd4d.png";